/* Measuring guide - Linenshed
   Opens the panel rendered by snippets/measure-guide.liquid.

   Three jobs:
   1. Insert the "how to measure" trigger after Globo's measurement fields,
      which are injected client-side and so cannot be placed from Liquid.
   2. Take over the existing size-chart trigger so both links open the same panel.
   3. Show only the measurements this product actually asks for, by reading the
      field labels Globo rendered. Falls back to showing all four.

   window.LSM_DEBUG() prints what it matched, for checking a product quickly.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-lsm]');
  if (!root) return;

  // The panel is rendered inside the product block, whose ancestors create a
  // stacking context - the sticky header then paints over the modal however
  // high its z-index. Moving it to <body> is the only reliable fix.
  if (root.parentNode !== document.body) document.body.appendChild(root);

  var vocabEl = document.querySelector('[data-lsm-vocab]');
  var VOCAB = vocabEl ? JSON.parse(vocabEl.textContent) : {};
  var ORDER = ['chest', 'waist', 'hip', 'inseam'];
  var lastMatch = null;

  /* ---------- matching ---------- */

  function norm(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')  // strip accents
      .replace(/\(.*?\)/g, ' ')                          // drop "(cm)"
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  // Verified on the live storefront: Globo keeps the option's FRENCH name in the
  // input's name attribute in every locale, and only the visible label is
  // translated by Langify. So the name attribute is the reliable key and the
  // label is the fallback.
  function keyForField(field) {
    return keyForText(field.getAttribute('name')) || keyForText(labelFor(field));
  }

  function keyForText(text) {
    var n = norm(text);
    if (!n) return null;
    var k, i, terms;
    for (k in VOCAB) {
      terms = VOCAB[k];
      for (i = 0; i < terms.length; i++) if (n === norm(terms[i])) return k;
    }
    for (k in VOCAB) {
      terms = VOCAB[k];
      for (i = 0; i < terms.length; i++) {
        var t = norm(terms[i]);
        if (t.length > 3 && (n.indexOf(t) !== -1 || t.indexOf(n) !== -1)) return k;
      }
    }
    return null;
  }

  // Label text for a field, without depending on Globo's own class names.
  function labelFor(field) {
    if (field.id) {
      var byFor = document.querySelector('label[for="' + CSS.escape(field.id) + '"]');
      if (byFor) return byFor.textContent;
    }
    var node = field;
    for (var depth = 0; depth < 4 && node; depth++) {
      node = node.parentElement;
      if (!node) break;
      var lab = node.querySelector('label');
      if (lab) return lab.textContent;
    }
    return field.getAttribute('placeholder') || field.name || '';
  }

  // Pick the container that actually holds the fields, not the first element
  // whose class happens to contain "gpo-".
  function globoContainer() {
    var exact = document.querySelector('.gpo-container');
    if (exact && exact.querySelector('input')) return exact;
    var all = document.querySelectorAll('.gpo-container, .gpo-app, [class*="gpo-"]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].querySelector('input[type="number"], input[type="text"]')) return all[i];
    }
    return exact || null;
  }

  function scanFields(container) {
    var fields = container.querySelectorAll('input[type="number"], input[type="text"], input:not([type])');
    var found = [], seen = {}, i, key, last = null;
    for (i = 0; i < fields.length; i++) {
      key = keyForField(fields[i]);
      if (key && !seen[key]) { seen[key] = 1; found.push(key); last = fields[i]; }
    }
    found.sort(function (a, b) { return ORDER.indexOf(a) - ORDER.indexOf(b); });
    return { keys: found, lastField: last };
  }

  /* ---------- panel ---------- */

  function applyKeys(keys) {
    var use = (keys && keys.length) ? keys : ORDER.slice();   // fallback: all four
    lastMatch = { matched: keys, shown: use };
    var n = 0;
    ORDER.forEach(function (k) {
      var on = use.indexOf(k) !== -1;
      if (on) n++;
      root.querySelectorAll('.lsm-steps li[data-key="' + k + '"]').forEach(function (li) {
        li.hidden = !on;
        var num = li.querySelector('.lsm-n');
        if (num && on) num.textContent = n;
      });
      root.querySelectorAll('.lsm-chip[data-key="' + k + '"]').forEach(function (c) {
        c.hidden = !on;
        if (on) c.textContent = n;
      });
      // the band drawn on the figure for this measurement
      root.querySelectorAll('.lsm-mark[data-step="' + (ORDER.indexOf(k) + 1) + '"]').forEach(function (g) {
        g.style.display = on ? '' : 'none';
      });
    });
  }

  function open(tab) {
    refresh();               // Globo may still have been rendering when we inserted
    // Badge apps mount late and can match our z-index; being last in <body> wins ties.
    if (root.parentNode !== document.body || root.nextElementSibling) {
      document.body.appendChild(root);
    }
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    setTab(tab || 'chart');
    var close = root.querySelector('[data-lsm-close]');
    if (close) close.focus();
  }

  function close() {
    root.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function setTab(name) {
    if (!root.querySelector('[data-lsm-tab="' + name + '"]')) name = 'chart';
    root.querySelectorAll('[data-lsm-tab]').forEach(function (b) {
      b.setAttribute('aria-selected', b.dataset.lsmTab === name ? 'true' : 'false');
    });
    root.querySelectorAll('[data-lsm-panel]').forEach(function (p) {
      p.hidden = p.dataset.lsmPanel !== name;
    });
  }

  root.querySelectorAll('[data-lsm-tab]').forEach(function (b) {
    b.addEventListener('click', function () { setTab(b.dataset.lsmTab); });
  });
  root.querySelectorAll('[data-lsm-gender]').forEach(function (b) {
    b.addEventListener('click', function () {
      var g = b.dataset.lsmGender;
      var grid = root.querySelector('.lsm-grid');
      if (grid) grid.dataset.lsmGenderState = g;
      root.querySelectorAll('[data-lsm-gender]').forEach(function (x) {
        x.setAttribute('aria-pressed', x.dataset.lsmGender === g ? 'true' : 'false');
      });
    });
  });
  var closeBtn = root.querySelector('[data-lsm-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);
  var scrim = root.querySelector('[data-lsm-scrim]');
  if (scrim) scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  /* ---------- take over the existing size-chart trigger ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-tool-tip="size-chart"]');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    open('chart');
  }, true);

  /* ---------- insert the measuring trigger after Globo's fields ---------- */

  var inserted = false;

  // Globo renders its fields progressively, so a single scan can catch two of
  // three. Re-scan whenever the DOM settles, and again when the panel opens.
  function refresh() {
    var c = globoContainer();
    if (!c) return;
    var scan = scanFields(c);
    if (scan.keys.length) applyKeys(scan.keys);
  }

  function insertTrigger() {
    if (inserted) return;
    if (!root.querySelector('[data-lsm-tab="measure"]')) return;   // bed linen: chart only
    var container = globoContainer();
    if (!container) return;

    var scan = scanFields(container);
    if (!scan.lastField) return;
    applyKeys(scan.keys);

    var tpl = document.querySelector('[data-lsm-trigger-template]');
    if (!tpl) return;
    var node = tpl.content ? tpl.content.firstElementChild.cloneNode(true)
                           : null;
    if (!node) return;

    var host = scan.lastField.closest('.gpo-option, .gpo-element, .gpo-field') ||
               scan.lastField.parentElement;

    // Wrap in a Globo column so the link picks up the same horizontal padding
    // as the field labels above it, whatever that padding happens to be.
    var wrap = document.createElement('div');
    wrap.className = 'gpo-element gpo-form__group gpo-col-12 lsm-trig-wrap';
    wrap.appendChild(node);
    host.parentNode.insertBefore(wrap, host.nextSibling);
    node.addEventListener('click', function (e) { e.preventDefault(); open('measure'); });
    inserted = true;
    syncType();
  }

  insertTrigger();

  var settle = null;
  var obs = new MutationObserver(function () {
    if (settle) clearTimeout(settle);
    settle = setTimeout(function () {
      insertTrigger();
      refresh();
    }, 120);
  });
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () {
    obs.disconnect();
    if (!lastMatch) applyKeys(null);
  }, 15000);

  // The theme resizes its labels at breakpoints. Rather than guess those sizes,
  // copy them from the size-chart link so the two can never disagree.
  function syncType() {
    var trig = document.querySelector('.lsm-trig');
    var ref = document.querySelector('.tool-tip-trigger__title') ||
              document.querySelector('.gpo-label');
    if (!trig || !ref) return;
    var s = getComputedStyle(ref);
    trig.style.fontSize = s.fontSize;
    trig.style.lineHeight = s.lineHeight;
    var ico = trig.querySelector('.lsm-trig-ico');
    if (ico) {
      var px = Math.round(parseFloat(s.fontSize) * 1.06);
      ico.style.width = px + 'px';
      ico.style.height = px + 'px';
    }
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncType, 150);
  });

  window.LSM_DEBUG = function () {
    var c = globoContainer();
    if (!c) return 'no Globo container found';
    var fields = c.querySelectorAll('input[type="number"], input[type="text"], input:not([type])');
    var out = [];
    fields.forEach(function (f) {
      var l = labelFor(f).replace(/\s+/g, ' ').trim();
      out.push({
        name: f.getAttribute('name'),
        label: l,
        matchedByName: keyForText(f.getAttribute('name')),
        matchedByLabel: keyForText(l),
        matched: keyForField(f)
      });
    });
    return { container: c.className, triggerInserted: inserted, result: lastMatch,
             fields: out, vocab: VOCAB };
  };
})();
